import { useState, useMemo } from 'react'
import { Stack, Button, Box, TextField } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';

export interface ICreateExcludedLegDialogProps {
    open : boolean;
    airlineList : {label: string, value: string}[];
    cancelAction : () => void;
    createAction : (airline : string, dep : string, dest : string) => void;
}

function ExcludedLegCreateDialog(props : ICreateExcludedLegDialogProps) {
    const { t } = useTranslation();
    const [ airlineCode, setAirlineCode] = useState('');
    const [ dep, setDep] = useState('');
    const [ dest, setDest] = useState('');
    
    const [ airlineCodeError, setAirlineCodeError] = useState(true);
    const [ depError, setDepError] = useState(true);
    const [ destError, setDestError] = useState(true);

    const handleDest = (e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let value = e.target.value;
        setDest(value);
        setDestError(value === undefined || value === '');
    }

    const handleDep = (e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        let value = e.target.value;
        setDep(value);
        setDepError(value === undefined || value === '');
    }

    const handleAirlineCode = (value : string | undefined) => {
        setAirlineCode(value ?? '');
        setAirlineCodeError(value === undefined || value === '');
    }

    const hasErrors = useMemo(() => {
        return airlineCodeError || depError || destError;
    }, [airlineCodeError, depError, destError]);

    return (
        <div>
        <Dialog open={props.open} onClose={props.cancelAction}>
            <DialogTitle>Exclude leg</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please define departure and destination station. For these legs meal order file won't show any pax meal figures.
                </DialogContentText>
                <Box>
                <Stack spacing={2} direction="column" sx={{ marginBottom: 4, marginTop: 1, paddingTop:2 }}>
                    <FormControl sx={{minWidth: 200 }} size="small">
                        <InputLabel id="airline-label">Airline</InputLabel>
                        <Select
                            labelId="airline-label"
                            id="airline-select"
                            value={airlineCode}
                            error={airlineCodeError}
                            label="Type"
                            onChange={(e) => handleAirlineCode(e.target.value) }>
                                { props.airlineList && props.airlineList.map((o)=> (
                                    <MenuItem  key={o.value} value={o.value}>{o.label}</MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                    <FormControl sx={{minWidth: 200 }} size="small">
                        <TextField
                                    type="text"
                                    variant='outlined'
                                    color='secondary'
                                    label={t('Departure')}
                                    onChange={e => handleDep(e)}
                                    value={dep}
                                    error={depError}
                                    helperText={depError ? 'Please enter a departure station' : ''}
                                    fullWidth
                                    size="small"
                        />
                    </FormControl>
                    <FormControl sx={{minWidth: 200 }} size="small">
                        <TextField
                                    type="text"
                                    variant='outlined'
                                    color='secondary'
                                    label={t('Destination')}
                                    onChange={e => handleDest(e)}
                                    value={dest}
                                    error={destError}
                                    helperText={destError ? 'Please enter a destination station' : ''}
                                    fullWidth
                                    size="small"
                        />
                    </FormControl>  
                </Stack>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.cancelAction}>Cancel</Button>
                <Button disabled={hasErrors} onClick={(e) => props.createAction(airlineCode, dep, dest) }>Create</Button>
            </DialogActions>
      </Dialog>
      </div>
    )
}

export default ExcludedLegCreateDialog;